import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { registerChunkLoadRecoveryHandlers } from './sdk/services/core/chunk-load-error.util';

import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
registerLocaleData(en);

require('raf/polyfill');

if (environment.production) {
  enableProdMode();
}

registerChunkLoadRecoveryHandlers();

function bootstrap() {
  bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]}).catch((err) => console.error(err));
}

// Deferred bundles often run after DOMContentLoaded already fired; listening only for that
// event then never runs bootstrap → blank screen (especially after live reload / HMR).
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap);
} else {
  bootstrap();
}
